module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/055-scotland-594fa530f1b7c022e5e4c887fc99e538.svg";